export default "__VITE_ASSET__32d8aa00__"